import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '../lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-ink/20 bg-transparent px-3 py-2 text-sm text-ink ring-offset-bg-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-ink/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate/40 dark:text-bg-light dark:ring-offset-bg-dark dark:placeholder:text-slate dark:focus-visible:ring-slate',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
